import BlockModel from '@wre/infinity-generators/SchemeOfLearning/Year4/Summer/PositionAndDirection/index';
import { newBlockContent } from '../../../Block';
import { newSmallStepContent } from '../../../SmallStep';

const Block = newBlockContent({
  block: 'PositionAndDirection',
  field: 'Geometry',
  weeks: [11, 12],
  smallSteps: [
    // Step 1
    newSmallStepContent({
      ...BlockModel.smallSteps[0],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Summer/PositionAndDirection/1DescribePositionUsingCoordinates" */ './1DescribePositionUsingCoordinates'
        )
    }),
    // Step 2
    newSmallStepContent({
      ...BlockModel.smallSteps[1],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Summer/PositionAndDirection/2PlotCoordinates" */ './2PlotCoordinates'
        )
    }),
    // Step 3
    newSmallStepContent({
      ...BlockModel.smallSteps[2],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Summer/PositionAndDirection/3Draw2DShapesOnAGrid" */ './3Draw2DShapesOnAGrid'
        )
    }),
    // Step 4
    newSmallStepContent({
      ...BlockModel.smallSteps[3],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Summer/PositionAndDirection/4TranslateOnAGrid" */ './4TranslateOnAGrid'
        )
    }),
    // Step 5
    newSmallStepContent({
      ...BlockModel.smallSteps[4],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Summer/PositionAndDirection/5DescribeTranslationOnAGrid" */ './5DescribeTranslationOnAGrid'
        )
    })
  ]
});
export default Block;
